import { useEffect, useState } from 'react';
import { GetApplicationManagementByID, GetWQSystems } from '../../_api';
import WQSystemTable from './components/WQSystemTable';
import WQSystemModal from './components/WQSystemModal';
import Section from '../../components/NewApplication/Section';
import AppManagementModel from '../../../../Classes/ResponseModels/ApplicationManagement/AppManagementModel';
import Spinner from '../../../../components/UI/Spinner/Spinner';
const WQSystemManagement = ({
	appID,
	currentUser,
	requirementNumber,
	readOnly,
}) => {
	const [app, setApp] = useState(new AppManagementModel());
	const [appSystems, setAppSystems] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	//on initial load, get AppManagementModel by ID, then set isLoading to false
	useEffect(() => {}, []);

	useEffect(() => {
		//load wq systems related to the selected application
		setIsLoading(true);
		GetApplicationManagementByID(appID)
			.then(res => {
				setApp(res);
			})
			.then(x => {
				GetWQSystems(appID)
					.then(data => {
						setAppSystems(data);
					})
					.then(x => {
						setIsLoading(false);
					});
			});
	}, [appID]);

	return (
		<Section label='Work Queue Management'>
			{!isLoading ? (
				<>
					<WQSystemTable
						systems={appSystems}
						appID={appID}
						app={app}
						currentUser={currentUser}
						requirementNumber={requirementNumber}
						readOnly={readOnly}
						setAppSystems={setAppSystems}
					/>
					<WQSystemModal
						appID={appID}
						app={app}
						currentUser={currentUser}
						requirementNumber={requirementNumber}
						readOnly={readOnly}
						isNew={true}
						setAppSystems={setAppSystems}
					/>
				</>
			) : (
				<Spinner />
			)}
		</Section>
	);
};

export default WQSystemManagement;
